import type { AuthContextUser } from './auth-context.types'

/**
 * Narrow getMe success payload: require at least one non-empty string among auth0Id, _id, email.
 */
export function identityFromGetMePayload(payload: unknown): AuthContextUser {
  if (payload === null || typeof payload !== 'object') {
    throw new Error('Session response was invalid')
  }
  const raw = payload as Record<string, unknown>
  const nonEmptyString = (v: unknown): string | undefined => {
    if (typeof v !== 'string') return undefined
    const t = v.trim()
    return t.length > 0 ? t : undefined
  }
  const auth0Id = nonEmptyString(raw.auth0Id)
  const mongoId = nonEmptyString(raw._id)
  const email = nonEmptyString(raw.email)
  const sub = auth0Id ?? mongoId ?? email
  if (!sub) {
    throw new Error('Session response was missing user identity')
  }
  return { sub, ...(email !== undefined ? { email } : {}) }
}
